export default {
    body: 'Inter, Inter-fallback, sans-serif',
    heading: 'Anton, Anton-fallback, sans-serif'
}
